import Navbar from "../../layout/Navbar";
import Container from "../../layout/Container";
import Icon from "../../components/Icon";
import {
  faAngleRight,
  faArrowRightFromBracket,
  faLanguage,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { USER_SIDEBAR_ROUTES } from "../../constant";
import { faPlusMinus } from "@fortawesome/free-solid-svg-icons/faPlusMinus";
import { useDispatch, useSelector } from "react-redux";
import { LoggedOut } from "../../store/slices/Auth";
import useWidth from "../../hooks/useWidth";
import MobileHeader from "../../layout/MobileHeader";
import back from "../../assets/images/leftArrow.svg";
import male from "../../assets/images/male.png";


export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const width = useWidth();
  const customer = useSelector( state => state.auth.customer )

  const handleLogout = () => {
    dispatch(LoggedOut());
    navigate("/");
  };

  return (
    <>
      <Navbar gradient />
      {width < 992 && (
        <MobileHeader gradient={true} height="200px">
          <div className="d-flex gap-3 justify-content-start align-items-center w-100 px-4">
            <div className="bg-info me-2 rounded-circle p-1" style={{ width: "35px", height: "35px" }} onClick={() => navigate(-1)}>
              <img src={back} alt="" className="w-100" />
            </div>
            <div className="text-light">
              <h5 className="mb-1">{ customer.firstname || "" } { customer.lastname || "" }</h5>
              <p className="mb-0">+91 xxx-xxx-{ customer.mobile.slice(-4)}</p>
            </div>
          </div>
        </MobileHeader>
      )}
      <Container>
        <section className={`user-profile mobile-top-space desktop-top-space`} >
          <div className="row m-0">
            {(width > 992 || location.pathname === "/user") && <div className="col-lg-3 col-md-12 col-sm-12 p-0">
              <div className="card rounded-4 p-3 m-lg-2">
                <p className="custom-text-color bold mb-2">Account Setting</p>
                <p className="fs-8">
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Hic,
                  nulla.
                </p>

                {USER_SIDEBAR_ROUTES.map((route, i) => (
                  <NavLink
                    to={route.path}
                    className="d-flex justify-content-between align-items-center my-1 cursor-pointer sidebar-links"
                    key={i}
                  >
                    <div className="d-flex align-items-center">
                      <p className="mb-0 me-2  fs-9">
                        <Icon
                          icon={route.icon}
                          className="p-2 rounded-circle "
                          style={{ background: "#dfdfdf" }}
                        />
                      </p>
                      <p className="custom-text-color mb-0">{route.name}</p>
                    </div>
                    <p className="mb-0">
                      <Icon icon={faAngleRight} className="me-2 " />
                    </p>
                  </NavLink>
                ))}
              </div>


              <div
                className="card rounded-4 p-3 m-lg-2 mt-2 cursor-pointer"
                onClick={handleLogout}
              >
                <div className="d-flex align-items-center">
                  <div
                    className="bg-primary rounded-circle d-flex justify-content-center align-items-center text-light"
                    style={{ width: "35px", height: "35px" }}
                  >
                    <Icon icon={faArrowRightFromBracket} />
                  </div>
                  <p className="custom-text-color bold mb-1 ms-2 fs-5">
                    Logout
                  </p>
                </div>
              </div>
            </div>}

            <div className="col-lg-9 col-md-12 col-sm-12 p-0">
              <div className="p-lg-2">
                <Outlet />
              </div>
            </div>
          </div>
        </section>
      </Container>
    </>
  );
};
